// =============================================================================
// FILE STATUS HEADER  (lihat /app/memory/MASTER_BLUEPRINT.md A7)
// status   : ACTIVE (Slice C1 — hook tema kecil)
// protected: NO
// =============================================================================
// Hook tema ringan: Terang / Gelap / Ikut Sistem. DEFAULT = Terang.
// Disimpan di localStorage PER PERANGKAT (try/catch). TANPA database/endpoint.
// Skrip di public/index.html memasang class "dark" LEBIH AWAL (anti-kedip).
import { useCallback, useEffect, useState } from "react";

export const THEME_KEY = "etams_v2_theme";
export const THEMES = ["light", "dark", "system"];

export const readStoredTheme = () => {
  try {
    const v = localStorage.getItem(THEME_KEY);
    return THEMES.includes(v) ? v : "light";
  } catch {
    return "light";
  }
};

const systemPrefersDark = () => {
  try {
    return window.matchMedia("(prefers-color-scheme: dark)").matches;
  } catch {
    return false;
  }
};

export const resolveTheme = (theme) =>
  theme === "system" ? (systemPrefersDark() ? "dark" : "light") : theme;

// Terapkan ke <html>: sumber kebenaran class "dark".
export const applyTheme = (theme) => {
  const resolved = resolveTheme(theme);
  const root = document.documentElement;
  root.classList.toggle("dark", resolved === "dark");
  root.style.colorScheme = resolved;
  return resolved;
};

// SLICE S-A2 (A-3): state DIPAKAI BERSAMA di tingkat modul + daftar subscriber, supaya
// semua pemanggil useTheme() berbagi satu nilai (tak ada instance basi seperti bug logo).
let _currentTheme = readStoredTheme();
const _subscribers = new Set();
const _notify = () => { _subscribers.forEach((fn) => fn(_currentTheme)); };

export const setThemeShared = (next) => {
  if (!THEMES.includes(next)) return;
  _currentTheme = next;
  try {
    localStorage.setItem(THEME_KEY, next);
  } catch {
    /* localStorage gagal -> abaikan; tema sesi tetap berlaku */
  }
  applyTheme(next);
  _notify();
};

export const useTheme = () => {
  const [theme, setLocal] = useState(_currentTheme);

  // Berlangganan perubahan bersama; sinkronkan bila nilai berubah sebelum subscribe.
  useEffect(() => {
    const fn = (t) => setLocal(t);
    _subscribers.add(fn);
    setLocal(_currentTheme);
    return () => { _subscribers.delete(fn); };
  }, []);

  const setTheme = useCallback((next) => { setThemeShared(next); }, []);

  // Terapkan saat mount & ketika pilihan berubah.
  useEffect(() => {
    applyTheme(theme);
  }, [theme]);

  // Ikuti perubahan sistem HANYA saat mode "system".
  useEffect(() => {
    if (theme !== "system") return undefined;
    let mq;
    try {
      mq = window.matchMedia("(prefers-color-scheme: dark)");
    } catch {
      return undefined;
    }
    const onChange = () => applyTheme("system");
    mq.addEventListener?.("change", onChange);
    return () => mq.removeEventListener?.("change", onChange);
  }, [theme]);

  return { theme, setTheme, resolved: resolveTheme(theme) };
};
